import { render, staticRenderFns } from "./registerSuccessTwo.vue?vue&type=template&id=56f70cf0&scoped=true&"
import script from "./registerSuccessTwo.vue?vue&type=script&lang=js&"
export * from "./registerSuccessTwo.vue?vue&type=script&lang=js&"
import style0 from "./registerSuccessTwo.vue?vue&type=style&index=0&id=56f70cf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f70cf0",
  null
  
)

export default component.exports